import {ReactNode} from "react";
import classes from "./BaseModal.module.css";
import Header, {HeaderProps} from "./header/Header";
import BaseModalContext from "./BaseModalContext";

type BaseModalPropsBase = {
    /**
     *
     * @author Kacper Faber
     * @since 0.1.9
    */
    opened: boolean;

    /**
     * On close
     * @author Kacper Faber
     * @since 0.1.9
    */
    onClose: () => void;

    /**
     * Children
     * @author Kacper Faber
     * @since 0.1.9
    */
    children: ReactNode | ReactNode[];

    /**
     * Delete the padding in a modal.
     * @author Kacper Faber
     * @since 0.1.9
    */
    noPadding?: boolean;
};

type BaseModalProps = BaseModalPropsBase & HeaderProps;

/**
 * Basic stylized modal
 * @author Kacper Faber
 * @since 0.1.9
*/
function BaseModal(props: BaseModalProps) {
    /**
     * Get padding class - props.noPadding
     * @author Kacper Faber
     * @since 0.1.9
    */
    const getPaddingClass = () => {
        return props.noPadding === true ? '' : classes.padding;
    }

    const getClasses = () => {
        return `${classes.root} ${props.opened ? classes.visible : ''} ${getPaddingClass()}`;
    };

    /**
     * Calls props.onClose(), so, parent element should close this element using state.
     * @author Kacper Faber
     * @since 0.1.9
    */
    const close = () => {
        props.onClose();
    }

    /**
     * Wrap BaseModalContext
     * @author Kacper Faber
     * @since 0.1.9
    */
    const wrapContext = (children: ReactNode) => {
        return (
            <BaseModalContext.Provider
                value={{ close }}
                children={children}
            />
        );
    }

    return wrapContext(
        <div className={getClasses()}>
            <div
                className={classes.overlay}
                onClick={close}
            />

            <div className={classes.modal}>
                <Header/>

                { props.children }
            </div>
        </div>
    );
}

export default BaseModal;